import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CpfCnpjPipe } from 'src/app/pipes/cpf-cnpj.pipe';
import { CaixaPostalService } from 'src/app/service/caixa-postal/caixa-postal.service';
import { ComunicadosService } from 'src/app/service/comunicados/comunicados.service';
import { SessionService } from 'src/app/service/session/session.service';
import { getSwal } from 'src/app/utils/swalObject';
import Swal from 'sweetalert2';
import * as moment from "moment";
import { Subscription } from 'rxjs';
import { Mensagem } from 'src/app/model/mensagem';
import { ApagarComunicacaoIndevidaService } from 'src/app/service/configuracao/apagar-comunicacao-indevida.service';
import { NgZone, ChangeDetectorRef } from '@angular/core';


type ComunicacaoMock = {
  protocolo: string;
  assunto: string;
  data: string;
  remetente: string;
  destinatario: string;
  mensagem: string;
};

@Component({
  selector: 'app-consulta-apagar-comunicacao-indevida',
  templateUrl: './consulta-apagar-comunicacao-indevida.component.html',
  styleUrls: ['./consulta-apagar-comunicacao-indevida.component.scss']
})
export class ConsultaApagarComunicacaoIndevidaComponent implements OnInit {

  @Input() view = 0;

  subscription: Subscription;

  loading: boolean = false;
  pesquisou: boolean = false;

  mensagens: any[] = [];
  mensagem: any = null;

  erroConsulta: string = '';

  itemsPerView: number = 10;

  data: any = {
    primeiraPagina: true,
    ultimaPagina: false,
    paginaAtual: 1,
    totalPaginas: 1,
    totalDeItems: 0,
    itemsPorPagina: 10,
  };

  filterCurrent: any = {
    pagina: 1,
    totalPagina: 10,
  };

  numeroComunicados: string = '10';
  cpfCnpjUsuario: string = '';
  filtroRespostasPaginacao: any = {};

  mensagemPrazoCiencia: string = '';
  mudarTexto: boolean = false;

  constructor(
    private caixaPostalService: CaixaPostalService,
    private docPipe: CpfCnpjPipe,
    private apagarComunicacaoIndevidaService: ApagarComunicacaoIndevidaService,
    private router: Router,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    const usuario = JSON.parse(localStorage.getItem('session'));
    this.cpfCnpjUsuario = usuario && usuario.usuario ? usuario.usuario.cpfCnpj : '';
    sessionStorage.removeItem('filtro');

    this.loading = false;
    this.pesquisou = false;
    this.mensagens = [];
    this.mensagem = null;
    this.erroConsulta = '';
  }

  consultarPorProtocolo(filtro: { protocolo: string }): void {
    const protocoloStr = filtro && filtro.protocolo ? String(filtro.protocolo).trim() : '';

    this.pesquisou = true;
    this.loading = true;
    this.erroConsulta = '';
    this.mensagem = null;
    this.mensagens = [];

    this.data.paginaAtual = 1;
    this.data.itemsPorPagina = this.itemsPerView || 10;

    if (!protocoloStr) {
      this.loading = false;
      this.erroConsulta = 'Informe um número de protocolo.';
      return;
    }

    const parametros: any = {};
    parametros['protocolo'] = protocoloStr;
    parametros['pagina'] = 1;
    parametros['paginaAtual'] = 1;
    parametros['total_pagina'] = this.data['itemsPorPagina'];

    this.filterCurrent = parametros;

    this.caixaPostalService.getMensagens(parametros).subscribe(
      (res: any) => {
        this.filtroRespostasPaginacao = { ...parametros };
        delete this.filtroRespostasPaginacao['pagina'];
        delete this.filtroRespostasPaginacao['paginaAtual'];
        delete this.filtroRespostasPaginacao['total_pagina'];

        this.processGetMessagesResult(res);
        this.loading = false;

        if (!this.mensagens || !this.mensagens.length) {
          this.erroConsulta = 'Nenhuma mensagem foi encontrada.';
        }
      },
      (err: any) => {
        this.loading = false;
        this.mensagens = [];
        this.erroConsulta = 'Nenhuma mensagem foi encontrada.';
        Swal.fire(getSwal('info', 'Ops!', 'Não foi possível consultar o protocolo informado.', 'ok', null));
      }
    );
  }

  openMessage(mensagem: any): void {
    this.mensagem = mensagem;
  }

  voltarParaGrid(): void {
    this.mensagem = null;
  }

  processGetMessagesResult(res: any): void {
    if (!res || !res.resultado) {
      this.mensagens = [];
      this.data['totalDeItems'] = 0;
      this.data['totalPaginas'] = 1;
      this.data['paginaAtual'] = 1;
      this.data['primeiraPagina'] = true;
      this.data['ultimaPagina'] = true;
      return;
    }

    res.resultado.forEach((mensagem: any) => {
      mensagem.remetenteTipo =
        mensagem.remetente.aplicacao && mensagem.remetente.aplicacao !== null
          ? 'aplicacao'
          : 'usuario';

      mensagem.destinatarioTipo =
        mensagem.destinatario.aplicacao && mensagem.destinatario.aplicacao !== null
          ? 'aplicacao'
          : 'usuario';

      mensagem.classDataEnvioIcon =
        mensagem.remetenteTipo === 'aplicacao' ? 'resposta-aplicacao' : 'resposta-usuario';

      mensagem.cienciaMensagem = mensagem.cienciaMensagem === null ? [] : mensagem.cienciaMensagem;

      mensagem.cienciaMensagem.forEach((cienciaMe: any) => {
        if (cienciaMe.usuario) {
          cienciaMe.usuario.cpfCnpj = this.docPipe.transform(cienciaMe.usuario.cpfCnpj);
        }
      });

      mensagem.mensagemLimpa = this.cleanMessage(mensagem.mensagem);
    });

    this.mensagens = res.resultado;

    this.mensagens.forEach((_m, index) => {
      if (this.mensagens[index].remetente.usuario === null) {
        this.mensagens[index].remetente = this.mensagens[index].remetente.aplicacao.descricao;
      } else {
        this.mensagens[index].remetenteCpfCnpj = this.mensagens[index].remetente.usuario.cpfCnpj;
        this.mensagens[index].remetente = this.mensagens[index].remetente.usuario.nomeRazaoSocial;
      }

      if (this.mensagens[index].destinatario.usuario === null) {
        this.mensagens[index].destinatarioNome = this.mensagens[index].destinatario.aplicacao.descricao;
      } else {
        this.mensagens[index].destinatarioNome = this.mensagens[index].destinatario.usuario.nomeRazaoSocial;
      }

      this.mensagens[index].dataEnvio = moment(this.mensagens[index].dataEnvio).format('DD/MM/YYYY');

      if (this.mensagens[index].leitura.length != 0) {
        this.mensagens[index].dataLeitura = moment(this.mensagens[index].leitura[0].dataCiencia).format('DD/MM/YYYY');
      } else {
        this.mensagens[index].dataLeitura = '';
      }

      if (this.mensagens[index].cienciaMensagem.length != 0) {
        if (this.mensagens[index].destinatario.aplicacao == null) {
          let dataCienciaEncontrada = '';
          this.mensagens[index].cienciaMensagem.forEach((c: any) => {
            if (
              c.usuario.cpfCnpj ==
              this.docPipe.transform(this.mensagens[index].destinatario.usuario.cpfCnpj)
            ) {
              dataCienciaEncontrada = moment(c.dataCiencia).format('DD/MM/YYYY');
            }
          });

          if (!dataCienciaEncontrada) {
            dataCienciaEncontrada = moment(this.mensagens[index].cienciaMensagem[0].dataCiencia).format('DD/MM/YYYY');
          }

          this.mensagens[index].dataCiencia = dataCienciaEncontrada;
        } else {
          this.mensagens[index].dataCiencia = moment(this.mensagens[index].cienciaMensagem[0].dataCiencia).format('DD/MM/YYYY');
        }
      } else {
        this.mensagens[index].dataCiencia = '';
      }

      if (this.mensagens[index].tipoComunicado.prazoCiencia > 0) {
        const dias = this.mensagens[index].tipoComunicado.prazoCiencia;

        this.mensagens[index].dataLimite = moment(this.mensagens[index].dataEnvio, 'DD/MM/YYYY HH:mm:ss')
          .add(dias, 'days')
          .format('DD/MM/YYYY');
      } else {
        this.mensagens[index].dataLimite = '';
      }
    });

    this.data['totalDeItems'] = res.totalRegistros;

    if (Math.round(this.data['paginaAtual']) > Math.round(res.totalPaginas)) {
      this.data['paginaAtual'] = 1;
    } else {
      this.data['totalPaginas'] = res.totalPaginas;
      this.data['paginaAtual'] = res.paginaAtual;
      this.data['primeiraPagina'] = res.primeiraPagina;
      this.data['ultimaPagina'] = res.ultimaPagina;
    }
  }

  next(): void {
    this.data['paginaAtual']++;
    this.onFilterChange(this.filterCurrent);
  }

  previous(): void {
    this.data['paginaAtual']--;
    this.onFilterChange(this.filterCurrent);
  }

  primeiraPagina(): void {
    this.data['paginaAtual'] = 1;
    this.onFilterChange(this.filterCurrent);
  }

  ultimaPagina(): void {
    this.data['paginaAtual'] = this.data['totalPaginas'];
    this.onFilterChange(this.filterCurrent);
  }

  onFilterChange(value: any): void {
    this.loading = true;

    value['pagina'] = this.data['paginaAtual'];
    value['total_pagina'] = this.data['itemsPorPagina'];
    value['paginaAtual'] = (this.data['paginaAtual'] = 1);

    this.filterCurrent = value;

    this.caixaPostalService.getMensagens(value).subscribe(
      (res: any) => {
        this.filtroRespostasPaginacao = { ...value };
        delete this.filtroRespostasPaginacao['pagina'];
        delete this.filtroRespostasPaginacao['paginaAtual'];
        delete this.filtroRespostasPaginacao['total_pagina'];

        this.processGetMessagesResult(res);
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.mensagens = [];
      }
    );
  }

  quantidadeComunicados(numeroComunicados: string): void {
    this.data['paginaAtual'] = 1;

    switch (numeroComunicados) {
      case '10':
        this.data['itemsPorPagina'] = 10;
        break;
      case '20':
        this.data['itemsPorPagina'] = 20;
        break;
      case '50':
        this.data['itemsPorPagina'] = 50;
        break;
      case '100':
        this.data['itemsPorPagina'] = 100;
        break;
      default:
        this.data['itemsPorPagina'] = 10;
        break;
    }

    this.loading = true;
    this.onFilterChange(this.filterCurrent);
  }

  calcularDias(dataVencimentoCiencia: any, mensagem: any): any {
    if (typeof dataVencimentoCiencia === 'string') {
      dataVencimentoCiencia = new Date(dataVencimentoCiencia.split('/').reverse().join('-'));
    }

    const hoje = new Date();
    const diferencaEmMilissegundos = dataVencimentoCiencia.getTime() - hoje.getTime();
    const diferencaEmDias = Math.ceil(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));

    let corComunicado = '';
    let diasTexto = '';

    if (mensagem.cienciaMensagem.length > 0) {
      if (diferencaEmDias === 0 && mensagem.cienciaMensagem[0].tacita == false) {
        diasTexto = 'Ciência realizada';
      } else if (mensagem.cienciaMensagem[0].tacita == true) {
        diasTexto = 'Ciência vencida e realizada por decurso de prazo';
      } else if (mensagem.cienciaMensagem[0].tacita == false) {
        diasTexto = 'Ciência realizada';
      } else if (diferencaEmDias > 0) {
        diasTexto = 'Ciência realizada';
      }
    } else {
      if (diferencaEmDias === 0) {
        diasTexto = 'Hoje';
      }
      if (diferencaEmDias < 0) {
        diasTexto = '';
      } else {
        diasTexto = diferencaEmDias === 1 ? '1 dia' : `${diferencaEmDias} dias`;
      }
    }

    return { dias: diasTexto, corComunicado: corComunicado };
  }

  getColor(tipoComunicado: any): string {
    if (tipoComunicado.cor !== null) {
      return tipoComunicado.cor.cor;
    }
    return '#a1a1a1';
  }

  getTextColor(tipoComunicado: any): string {
    if (tipoComunicado.cor !== null) {
      if (tipoComunicado.cor.cor === '#ffffff') {
        return '#000000';
      }
      return tipoComunicado.cor.cor === '#ffffff' ? '#000000' : '#ffffff';
    }
    return '#ffffff';
  }

  corNovoComunicado(mensagem: any): string {
    let usuario = JSON.parse(localStorage.getItem('session'));
    this.cpfCnpjUsuario = usuario.usuario.cpfCnpj;

    let corComunicado = '';
    let diferencaEmDias: number;

    const dataVencimentoCiencia = new Date(mensagem.dataLimite.split('/').reverse().join('-'));
    dataVencimentoCiencia.setDate(dataVencimentoCiencia.getDate() + 1);

    const hoje = new Date();
    const diferencaEmMilissegundos = dataVencimentoCiencia.getTime() - hoje.getTime();
    diferencaEmDias = Math.ceil(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));

    if (mensagem.leitura.length !== 0 && mensagem.respostas.length === 0) {
      if (mensagem.destinatario.aplicacao == null) {
        mensagem.leitura.forEach(() => {
          corComunicado = '#e4e4e479';
          if (mensagem.cienciaMensagem.length != 0) {
            if (mensagem.cienciaMensagem[0].tacita == true) {
              corComunicado = '#ff1b1b5c';
            }
          }
        });
      } else {
        mensagem.leitura.forEach((res: any) => {
          if (res.usuario.cpfCnpj !== mensagem.remetenteCpfCnpj) {
            corComunicado = '#e4e4e479';
          }
        });
      }
    } else if (mensagem.respostas.length !== 0) {
      corComunicado = this.verificarRespostas(mensagem.respostas);
    } else if (mensagem.cienciaMensagem.length > 0 && mensagem.respostas.length === 0) {
      const dataVenc = new Date(mensagem.dataLimite.split('/').reverse().join('-'));
      dataVenc.setDate(dataVenc.getDate() + 1);

      const hj = new Date();
      const diffMs = dataVenc.getTime() - hj.getTime();
      const diffDias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

      if (diffDias === 0 && mensagem.cienciaMensagem[0].tacita == false) {
        corComunicado = '#e4e4e479';
      } else if (mensagem.cienciaMensagem[0].tacita == true) {
        corComunicado = '#ff1b1b5c';
      } else if (mensagem.cienciaMensagem[0].tacita == false) {
        corComunicado = '#e4e4e479';
      } else if (diffDias > 0) {
        corComunicado = '#e4e4e479';
      }
    }

    if (mensagem.cienciaMensagem.length == 0 && mensagem.respostas.length === 0 && diferencaEmDias >= 0) {
      corComunicado = '#ffff3845';
    } else if (mensagem.cienciaMensagem.length == 0 && diferencaEmDias < 0) {
      corComunicado = '#ff1b1b5c';
    }

    if (mensagem.cienciaMensagem.length > 0) {
      const mensagemCiencia = mensagem.cienciaMensagem[mensagem.cienciaMensagem.length - 1];

      if (mensagemCiencia.tacita === true) {
        this.mensagemPrazoCiencia = 'Ciência vencida e realizada por decurso de prazo';
        corComunicado = '#ff1b1b5c';
      } else {
        this.mensagemPrazoCiencia = 'Ciência realizada';
      }
    }

    return corComunicado;
  }

  verificarRespostas(resposta: any[]): string {
    let corComunicado: string;
    let destinatario: any;

    resposta.forEach((res: any) => {
      if (res.destinatario.usuario !== null) {
        destinatario = res.destinatario.usuario.cpfCnpj;
      } else {
        destinatario = 'Plataforma dt-e';
      }

      if (res.leitura.length !== 0 && res.respostas.length == 0) {
        res.leitura.forEach((leitura: any) => {
          if (leitura.usuario.cpfCnpj == destinatario || (destinatario == 'Plataforma dt-e' && leitura.usuario.cpfCnpj)) {
            corComunicado = '#e4e4e479';
          }
        });
      } else if (res.respostas.length == 0 && res.leitura.length == 0) {
        corComunicado = null;
      } else if (res.leitura.length == 0) {
        corComunicado = null;
      } else if (res.respostas.length !== 0) {
        corComunicado = this.verificarRespostas(res.respostas);
      }
    });

    return corComunicado;
  }

  cleanMessage(message: string): string {
    return message ? message.toLowerCase().split('<br>').join(' ') : '';
  }

  async apagarComunicacao(): Promise<void> {
    const confirmou = await this.abrirModalConfirmacaoProtocolo();
    if (!confirmou) return;

    const protocolo = this.mensagem.protocolo;

    this.apagarComunicacaoIndevidaService.apagarComunicacaoIndevida(protocolo).subscribe(
      (res) => {
        Swal.fire(getSwal('success', '', 'A comunicação foi apagada com sucesso.', 'ok', null))
          .then(() => {
            this.ngZone.run(() => {
              this.mensagem = null;
              this.mensagens = [];
              this.pesquisou = false;

              this.cdr.detectChanges();

              this.router.navigateByUrl('/configuracao/apagar-comunicacao-indevida');
            });
          });
        },
        (err) => {
          Swal.fire(getSwal('error', 'Ops!', 'Não foi possível apagar a comunicação.', 'ok', null));
        }
    );
  }

  setSelectedEntities(_event: any): void { }
  showData(_index: number): void { }
  alerta(): void { }

  private async abrirModalConfirmacaoProtocolo(): Promise<boolean> {
    try {
      const protocoloOriginal = String(this.mensagem.protocolo || '').trim();

      const result = await Swal.fire({
        title: 'Confirmação',
        text: 'Este processo é irreversível. Digite novamente o número do protocolo para confirmar.',
        input: 'text',
        inputPlaceholder: 'Digite o protocolo',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
        inputValidator: (value) => {
          const digitado = String(value || '').trim();

          if (!digitado) return 'Digite o número do protocolo para continuar.';

          if (digitado !== protocoloOriginal) {
            return 'O número do protocolo informado não corresponde ao original. A operação foi cancelada.';
          }

          return null;
        },
      } as any);

      return !!result.isConfirmed;
    } catch (_e) {
      Swal.fire(getSwal('error', 'Erro', 'Não foi possível validar o protocolo.', 'ok', null));
      return false;
    }
  }
}
